import { ModalAlert } from "@mixitone/components";
import { ApplicationView, useController } from "@mixitone/mvc";
import { FormController } from "./FormController";

interface DeleteModalProps {
  name: string;
  archive?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ name, archive }) => {
  const controller = useController(FormController);
  const { saving } = controller.state;
  const message =
    controller.deleteMessage() ?? `Are you sure you want to ${archive ? "archive" : "delete"} this ${name}?`;

  if (!controller.state.showDeleteModal) {
    return null;
  }

  return (
    <ModalAlert
      title={`${archive ? "Archive" : "Delete"} ${name}`}
      message={message}
      onConfirm={() => controller.actionConfirmDelete()}
      onCancel={() => controller.actionCancelDelete()}
      confirmText="Yes"
      cancelText="No"
      loading={saving}
    />
  );
};

export default ApplicationView(DeleteModal);
